module.exports = __webpack_public_path__ + "img/palmar-pool-2.cc23a33a.jpg";